import { render } from "./BestPlayerVoting.vue?vue&type=template&id=793f20e2&scoped=true"
import script from "./BestPlayerVoting.vue?vue&type=script&lang=js"
export * from "./BestPlayerVoting.vue?vue&type=script&lang=js"

import "./BestPlayerVoting.vue?vue&type=style&index=0&id=793f20e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793f20e2"]])

export default __exports__